(() => {
  const key = 'cc_device';
  const read = () => { try { return localStorage.getItem(key) || ''; } catch { return ''; } };
  const update = (model) => {
    document.querySelectorAll('[data-cc-device-label]').forEach(el => {
      el.dataset.empty ||= el.textContent;
      el.textContent = model || el.dataset.empty;
    });
    document.querySelectorAll('[data-cc-device]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.ccDevice === model)));
    document.querySelectorAll('a[data-cc-collection]').forEach(el => {
      const url = new URL(el.href, location.origin);
      if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', 'manual');
      if (model) url.searchParams.set('filter.v.option.size', model);
      else url.searchParams.delete('filter.v.option.size');
      el.href = url.pathname + url.search;
    });
  };
  window.CCDevice = {
    get: read,
    set(model) {
      try { model ? localStorage.setItem(key, model) : localStorage.removeItem(key); } catch {}
      update(model);
      document.dispatchEvent(new CustomEvent('cc:device-change', { detail: { model } }));
    },
    refresh: () => update(read())
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cc-device-open]');
    if (opener) { document.getElementById('CCDeviceSheet')?.showModal(); return; }
    const close = event.target.closest('[data-cc-dialog-close]');
    if (close) close.closest('dialog')?.close();
    const device = event.target.closest('[data-cc-device]');
    if (device) { window.CCDevice.set(device.dataset.ccDevice); device.closest('dialog')?.close(); }
    if (event.target.closest('[data-cc-forget]')) { window.CCDevice.set(''); document.getElementById('CCDeviceSheet')?.close(); }
  });
  document.addEventListener('click', event => {
    if (event.target.tagName === 'DIALOG') {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  const sheet = document.getElementById('CCDeviceSheet');
  const models = [...(sheet?.querySelectorAll('[data-cc-device]') || [])];
  const generations = [...new Set(models.map(el => el.dataset.ccDevice.match(/\d+/)?.[0] || 'SE'))];
  generations.forEach((generation, index) => {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'cc-chip'; button.textContent = generation;
    const choose = () => {
      sheet.querySelectorAll('[data-cc-generations] button').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      models.forEach(el => el.hidden = (el.dataset.ccDevice.match(/\d+/)?.[0] || 'SE') !== generation);
    };
    button.addEventListener('click', choose);
    sheet.querySelector('[data-cc-generations]').append(button);
    if (index === 0) choose();
  });
  window.addEventListener('storage', event => { if (event.key === key) { update(read()); document.dispatchEvent(new CustomEvent('cc:device-change', {detail:{model:read()}})); } });
  document.addEventListener('shopify:section:load', window.CCDevice.refresh);
  update(read());
  const header = document.querySelector('.section-header');
  if (header && 'ResizeObserver' in window) new ResizeObserver(() => document.documentElement.style.setProperty('--cc-header-height', `${header.offsetHeight}px`)).observe(header);
})();
